import { Ng1StateDeclaration } from "@uirouter/angularjs";
import {
  buildTransactionComponentConfig,
  PartTransactionComponentConfig,
  PartTransactionConfigMachine,
} from "./config";

import { vsComponentName } from "./index";

export function getMachinePartTransactionState(): Ng1StateDeclaration {
  return {
    url: "/parts",
    component: vsComponentName,
    resolve: {
      defaultQuery: [
        "machine",
        (machine: any) => ({
          ContextPath: "MachineId",
          ContextValue: machine?.Id,
        }),
      ],
      config: [
        (): PartTransactionComponentConfig =>
          buildTransactionComponentConfig({
            actionGroupNames: [PartTransactionConfigMachine],
            showMachineFilter: false,
            showPartOrderFilter: false,
            showPartRoomFilter: false,
          }),
      ],
    },
  };
}
